import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from '../website/HomePage.vue'
import TechnologyPage from '../website/TechnologyPage.vue'
import ProductsPage from '../website/ProductsPage.vue'
import QualityPage from '../website/QualityPage.vue'
import SalesPage from '../website/SalesPage.vue'
import CustomersPage from '../website/CustomersPage.vue'
import ContactPage from '../website/ContactPage.vue'
import AboutPage from '../website/AboutPage.vue'
import Website404 from '../website/Website404.vue'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/technology',
    name: 'Technology',
    component: TechnologyPage
  },
  {
    path: '/products',
    name: 'Products',
    component: ProductsPage
  },
  {
    path: '/quality',
    name: 'Quality',
    component: QualityPage
  },
  {
    path: '/sales',
    name: 'Sales',
    component: SalesPage
  },
  {
    path: '/customers',
    name: 'Customers',
    component: CustomersPage
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: Website404
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 全局前置守卫 - 处理未知路由跳转到404页面
router.beforeEach((to, from, next) => {
  // 如果路由匹配到404页面，直接放行
  if (to.matched.length > 0) {
    return next()
  }
  
  // 如果没有匹配到任何路由，跳转到404页面
  next({ name: 'NotFound' })
})

export default router